import { render, staticRenderFns } from "./ownerDetailAccountReceipt.vue?vue&type=template&id=737c1d40"
import script from "./ownerDetailAccountReceipt.vue?vue&type=script&lang=js"
export * from "./ownerDetailAccountReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports